import aframe from 'aframe';

aframe.registerComponent("paused", {
  schema: { default: true },
  init() {
    this.oldPlay = this.el.play;
    this.el.play = this.wrapPlay(this.el.play);
  },
  update(oldData) {
    if (oldData !== true && this.data === true) {
      this.el.pause();
    } else if (oldData === true && this.data !== true) {
      this.el.play();
    }
  },
  remove() {
    this.el.play = this.oldPlay;
    if (this.data === true) {
      this.el.play();
    }
  },
  wrapPlay(playFunction) {
    return () => {
      if (this.data !== true) {
        playFunction.call(this.el);
      }
    }
  }
});
